import React, { useState, useEffect } from "react";
import grey from "@material-ui/core/colors/grey";
import StopSharpIcon from "@material-ui/icons/StopSharp";
import PropTypes from "prop-types";
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Button from "@material-ui/core/Button";
import {
  withStyles,
  makeStyles,
  createStyles,
  useTheme,
} from "@material-ui/core/styles";
import clsx from "clsx";
import Box from "@material-ui/core/Box";
import {
  FormHelperText,
  Input,
  InputLabel,
  InputBase,
} from "@material-ui/core";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import FormLabel from "@material-ui/core/FormLabel";
import Checkbox from "@material-ui/core/Checkbox";
import {
  DatePicker, KeyboardDatePicker
} from '@material-ui/pickers';
import CalendarTodayIcon from '@material-ui/icons/CalendarToday';
import { reportFilterTot } from "./ReportObj"
import { ToastError } from "../../services/ToastMsg";

const useStyles = makeStyles((theme) => ({
  justifyContentBetween: {
    justifyContent: "space-between!important",
  },
  alignItemsStretch: {
    alignItems: "stretch",
  },
  borderRight: {
    borderRight: "1px solid " + grey[400],
  },
  MuiButtonBaseRoot: {
    borderRadius: 4,
    padding: 0,
    paddingBottom: "2px",
    color: grey[400],
  },
  MuiSvgIconRoot: {
    color: "#ff4717",
    border: "2px solid " + grey[400],
    fontSize: "1.3rem",
    borderRadius: 3,
  },
  anchorTag: {
    textDecoration: "none",
    cursor: "pointer",
  },
  btnStyle2: {
    borderRadius: "8px",
    border: "2px solid #ff4717",
    boxShadow: "2px 2px 4px 2px #dadada",
    color: "#ffffff",
    background: "#ff4717 !important",
    textTransform: "capitalize",
    padding: "4px 22px",
    marginRight: "8px"
  },
}));
const BootstrapInput = withStyles((theme) => ({
  root: {
    "label + &": {
      marginTop: theme.spacing(2),
    },
  },

  input: {
    borderRadius: 4,
    position: "relative",
    backgroundColor: theme.palette.common.white,
    border: "1px solid #ced4da",
    fontSize: 16,
    width: "auto",
    padding: "10px 12px",
    height: "0.1876em",
    // marginLeft: '2.2em',
    transition: theme.transitions.create(["border-color", "box-shadow"]),
    // Use the system font instead of the default Roboto font.
    fontFamily: [
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(","),
    "&:focus": {
      // boxShadow: `${fade(theme.palette.primary.main, 0.25)} 0 0 0 0.2rem`,
      borderColor: theme.palette.primary.main,
    },
  },
}))(InputBase);

const BootstrapDate = withStyles((theme) => ({
  root: {
    "label + &": {
      marginTop: theme.spacing(2),
    },
  },

  input: {
    borderRadius: 4,
    position: "relative",
    backgroundColor: theme.palette.common.white,
    border: "1px solid #ced4da",
    fontSize: 16,
    width: "100%",
    padding: "10px 12px",
    height: "0.1876em",
    // marginLeft: '2.2em',
    transition: theme.transitions.create(["border-color", "box-shadow"]),
    // Use the system font instead of the default Roboto font.
    fontFamily: [
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(","),
    "&:focus": {
      // boxShadow: `${fade(theme.palette.primary.main, 0.25)} 0 0 0 0.2rem`,
      borderColor: theme.palette.primary.main,
    },
  },
}))(InputBase);
 export default function FiltersReportTot(props) {
  const classes = useStyles();
  const [filter, setFilter] = React.useState(true);
  const [selectedStartDate, handleStartChange] = useState(new Date());
  const [selectedEndDate, handleEndChange] = useState(new Date());
const {filterReportTot, clearFilter} = props;
  const [formObj, setFormObj] = useState(reportFilterTot);
  const [selectedValue, setSelectedValue] = React.useState('All');
  const handleChange = (event) => {
    setSelectedValue(event.target.value);
    setFormObj({ ...formObj, [event.target.name]: event.target.value });
  };
  const onChangeText = (event) => {
    setFormObj({ ...formObj, [event.target.name]: event.target.value });
};
const applyFilter = () =>{
 
        filterReportTot(formObj);
 
  };
  const onClearFilter = () =>{
    setFormObj(reportFilterTot);
    clearFilter();
  }
  const handleDateData = (event, type) => {
    let dateFormat = "";
    if(event){
       dateFormat = event.format('YYYY-MM-DD');
    }
    setFormObj({ ...formObj, [type]: dateFormat });
    // ////console.log(event, type);
  }
  {/*const applyFilter = () =>{
    if(isNaN(formObj.contract) && formObj.contract != ""){
      ToastError("Please enter valid Client Contract");
    } else if(isNaN(formObj.vessel) && formObj.vessel != ""){
      ToastError("Please enter valid Vessel IMO");
    }  else {
      filterReportTot(formObj);
    }
    ////console.log(formObj);
  };*/}
  return (
    <div>
      <Box
        component="div"
        px={1}
        pt={1.2}
        pb={1}
        display="flex"
        className={clsx(
          classes.justifyContentBetween,
          classes.alignItemsStretch
        )}
      >
        <Box component="h2" m={0} className="blcopy" fontWeight="500" pl={2}>
          Filters:
        </Box>
        {/* <Box
          component="a"
          href="javascript:void(0)"
          color={grey}
          className={classes.anchorTag  + " hide-link"}
          onClick={() => {
            setFilter(!filter);
          }}
          fontSize="13px"
        >
          {filter ? "Hide Filter" : "Show Filter"}
        </Box> */}
      </Box>
      <Box
        component="div"
        px={1}
        pt={1}
        pb={2}
        display={filter ? "flex" : "none"}
        className={clsx(
          classes.justifyContentBetween,
          classes.alignItemsStretch
        )}
      >
        <Grid container spacing={3} className="reports-filter-row" >
          <Grid className="reports-filter-col">
            <Box
              component="div"
              className="reports-filter"
              pl={2}
            >
              <Box
                component="div"
                display="flex"
                className={classes.justifyContentBetween}
                pb={3}
              ></Box>
              <Box
                component="div"
                display="flex"
                className="re-filter-input"
                pb={1}
              >
                <Box component="label"  >
                  Serial Number
            </Box>
                <Box component="div" className="re-filter-box">
                  <BootstrapInput name="transformer"
                  value={formObj.transformer || ""}
                   onChange={onChangeText}
                  />
                </Box>
              </Box>
              <Box
                component="div"
                display="flex"
                className="re-filter-input"
                pb={1}
              >
                <Box component="label"  >
                  Client Id
            </Box>
                <Box component="div" className="re-filter-box">
                  <BootstrapInput name="contract"
                  value={formObj.contract || ""}
                   onChange={onChangeText} />
                </Box>
              </Box>
              <Box
                component="div"
                display="flex"
                className="re-filter-input"
                pb={1}
              >
                <Box component="label"  >
                  Location
            </Box>
                <Box component="div" className="re-filter-box">
                  <BootstrapInput name="location"
                    value={formObj.location || ""}
                    onChange={onChangeText} />
                </Box>
              </Box>
              {/* <Box
                component="div"
                display="flex"
                className="re-filter-input"
              >
                <Box component="label" >
                  Vessel IMO
            </Box>
                <Box component="div" className="re-filter-box">
                  <BootstrapInput name="Vessel"
                    value={formObj.Vessel || ""}
                    onChange={onChangeText} />
                </Box>
              </Box> */}
            </Box>
          </Grid>
          <Grid className="reports-filter-col">
            <Box
              component="div"
              className="reports-filter"
              pl={2}
            >
              <Box
                component="div"
                display="flex"
                className={classes.justifyContentBetween}
                pb={3}
              ></Box>
              <Box
                component="div"
                display="flex"
                className="re-filter-input"
                pb={1}
              >
                <Box component="label"  >
                  Manufacturer
            </Box>
                <Box component="div" className="re-filter-box">
                  <BootstrapInput disabled />
                </Box>
              </Box>
              <Box
                component="div"
                display="flex"
                className="re-filter-input"
                pb={1}
              >
                <Box component="label"  >
                  Sample Number
            </Box>
                <Box component="div" className="re-filter-box">
                  <BootstrapInput 
                  name="sampleNumber"
                  value={formObj.sampleNumber || ""}
                    onChange={onChangeText} />
            </Box>
              </Box>
              <Box
                component="div"
                display="flex"
                className="re-filter-input"
                pb={1}
              >
                <Box component="label"  >
                  Rating
            </Box>
                <Box component="div" className="re-filter-box">
                  <BootstrapInput name="rating"
                    value={formObj.rating || ""}
                    onChange={onChangeText} />
                </Box>
              </Box>
              {/* <Box
                component="div"
                display="flex"
                className="re-filter-input"
              >
                <Box component="label" >
                  Offspec Results
            </Box>
                <Box component="div" className="re-filter-box">
                  <BootstrapInput disabled />
                </Box>
              </Box> */}
            </Box>
          </Grid>
          <Grid className="reports-filter-col report-date-col">
            <Box
              component="div"
              className="reports-filter"
              pl={2}
            >
              <Box
                component="div"
                display="flex"
                className={classes.justifyContentBetween}
                pb={3}
              ></Box>
              <Box
                component="div"
                display="flex"
                className="re-filter-input"
                pb={1}
              >
                <Box component="label"  >
                  Voltage
            </Box>
                <Box component="div" className="re-filter-box">
                  <BootstrapInput name="voltage"
                    value={formObj.voltage || ""}
                    onChange={onChangeText} />
                </Box>
              </Box>
              {/* <Box
                component="div"
                display="flex"
                className="re-filter-input"
                pb={1}
              >
                <Box component="label"  >
                  ISO Specification
            </Box>
                <Box component="div" className="re-filter-box">
                  <BootstrapInput disabled />
                </Box>
              </Box> */}
              <Box
                component="div"
                display="flex"
                className="re-filter-input"
                py={1}

              >
                <Box component="label" >
                  Reported Date
            </Box>
                {/* <Box component="div">
              <BootstrapInput />
            </Box> */}
                <Box component="span" className=" date-input pad-right-1"   >

                <KeyboardDatePicker

                margin="normal"
                id="date-picker-dialog"
                // label="Date picker dialog"
                format="DD/MM/yyyy"
                invalidDateMessage="" 
                value={formObj.reportedFromDate || ""}
                onChange={(event)=>{handleDateData( event, "reportedFromDate")}}
                KeyboardButtonProps={{
                  'aria-label': 'change date',
                }}
                />

                </Box>
                <Box component="span" className=" date-input" mr="2"  >
                <KeyboardDatePicker

                  margin="normal"
                  id="date-picker-dialog"
                  // label="Date picker dialog"
                  format="DD/MM/yyyy"
                  invalidDateMessage="" 
                  value={formObj.reportedToDate || ""}
                  onChange={(event)=>{handleDateData( event, "reportedToDate")}}
                  KeyboardButtonProps={{
                    'aria-label': 'change date',
                  }}
                  />
                </Box>
              </Box>
              <Box
                component="div"
                display="flex"
                className="re-filter-input"
              >
                <Box component="label"  >
                  Sampled Date
            </Box>
                <Box component="span" className="date-input pad-right-1 "   >
                <KeyboardDatePicker

                  margin="normal"
                  id="date-picker-dialog"
                  // label="Date picker dialog"
                  format="DD/MM/yyyy"
                  invalidDateMessage="" 
                  value={formObj.sampledFromDate || ""}
                  onChange={(event)=>{handleDateData( event, "sampledFromDate")}}
                  KeyboardButtonProps={{
                    'aria-label': 'change date',
                  }}
                  />
                </Box>
                <Box component="span" className="date-input  "  >
                <KeyboardDatePicker

                  margin="normal"
                  id="date-picker-dialog"
                  // label="Date picker dialog"
                  format="DD/MM/yyyy"
                  invalidDateMessage="" 
                  value={formObj.sampledToDate || ""}
                  onChange={(event)=>{handleDateData( event, "sampledToDate")}}
                  KeyboardButtonProps={{
                    'aria-label': 'change date',
                  }}
                  />
                </Box>
              </Box>
            </Box>
          </Grid>
          <Grid className="reports-filter-col">
            <Box component="div">
              <Box
                component="div"
                display="flex"
                className={classes.justifyContentBetween}
                alignItems="flex-end"
                height={1}
              >
                <Box component="div" width={1} display="block" className="report-status">
                  <Box
                    component="div"
                    fontWeight="bold"

                    display="flex" className="blcopy"
                    pb={1}
                    pt={3}
                  >
                    Report Status
              </Box>
                  <Box
                    component="div"
                    display="block"
                    className={classes.justifyContentBetween + " reports-radio"}
                  >
                    
                  <RadioGroup
                    row
                    aria-label="position"
                    name="statusType"
                    defaultValue="top"
                    value={formObj.statusType}
                    onChange={onChangeText}
                  >
                    <Box component="div" alignItems="center" width={1} display="block">
                      <FormControlLabel value="All"  control={<Radio className={classes.radioInput} />}
                      labelPlacement="start" />
                      <Box component="span" ml={1} display="inlin-block" >
                        {"All"}
                      </Box>
                    </Box>
                    <Box component="div" alignItems="center" width={1}  display="block">
                      <FormControlLabel value="Critical"  control={<Radio className={classes.radioInput} />}
                      labelPlacement="start" />
                      <Box component="span" ml={1} display="inlin-block"  >
                      {"Critical"}
                  </Box>
                    </Box>
                    <Box component="div" alignItems="center" width={1}  display="block">
                      <FormControlLabel value="Warning"  control={<Radio className={classes.radioInput} />}
                      labelPlacement="start" />
                      <Box component="span" ml={1} display="inlin-block"  >
                        {"Warning"}
                      </Box>
                    </Box>
                    <Box component="div" alignItems="center" width={1}  display="block">
                      <FormControlLabel value="Satisfactory"  control={<Radio className={classes.radioInput} />}
                      labelPlacement="start" />
                      <Box component="span" ml={1}  display="inlin-block">
                        {"Satisfactory"}
                      </Box>
                    </Box>
                     <Box component="div" alignItems="center" width={1}  display="block">
                       <FormControlLabel value="Other"  control={<Radio className={classes.radioInput} />}
                      labelPlacement="start" />
                      <Box component="span" ml={1} display="inlin-block"  >
                        {"Other"}
                      </Box>
                    </Box> 
                  </RadioGroup>
                      {/* <RadioGroup
                    row
                    aria-label="position"
                    name="status"
                    defaultValue="top"
                    value={formObj.status}
                    onChange={onChangeText}
                  >
                    <Box component="div" alignItems="center" width={1} display="block">
                      <FormControlLabel value="All"  control={<Radio className={classes.radioInput} />}
                      labelPlacement="start" />
                      <Box component="span" ml={1} display="inlin-block" >
                        {"All"}
                      </Box>
                    </Box>
                    <Box component="div" alignItems="center" width={1}  display="block">
                      <FormControlLabel value="Pass"  control={<Radio className={classes.radioInput} />}
                      labelPlacement="start" />
                      <Box component="span" ml={1} display="inlin-block"  >
                  Pass
                  </Box>
                    </Box>
                    <Box component="div" alignItems="center" width={1}  display="block">
                      <FormControlLabel value="Caution"  control={<Radio className={classes.radioInput} />}
                      labelPlacement="start" />
                      <Box component="span" ml={1} display="inlin-block"  >
                        {"Caution"}
                      </Box>
                    </Box>
                    <Box component="div" alignItems="center" width={1}  display="block">
                      <FormControlLabel value="Action"  control={<Radio className={classes.radioInput} />}
                      labelPlacement="start" />
                      <Box component="span" ml={1}  display="inlin-block">
                        {"Action"}
                      </Box>
                    </Box>
                    <Box component="div" alignItems="center" width={1}  display="block">
                       <FormControlLabel value="other"  control={<Radio className={classes.radioInput} />}
                      labelPlacement="start" />
                      <Box component="span" ml={1} display="inlin-block"  >
                        {"other"}
                      </Box>
                    </Box>
                  </RadioGroup> */}
                  </Box>
                </Box>
              </Box>
            </Box>
          </Grid>
        </Grid>

      </Box>
      <Box component="div" >
        <Grid container spacing={3} className="reports-filter-row" >
        <Grid className="reports-apply-filter-btn">
            <Button type="button" onClick={applyFilter} className={classes.btnStyle2}>
              Apply Filter
            </Button>
          </Grid>
          <Grid className="reports-apply-filter-btn">
            <Button type="button" onClick={onClearFilter} className={classes.btnStyle2}>
              Clear
            </Button>
          </Grid>
        </Grid>
      </Box>
    </div>
  );
}

